export default __webpack_public_path__ + "static/media/logout.3cd77f59.svg";